"use strict";

export default {
  bind: () => {
    let $abas = document.querySelector(".abas"),
      $btns = document.querySelectorAll(".abas--btn"),
      $cards = document.querySelectorAll(".cards"),
      verifyBtn = document.querySelectorAll(".cards[data-card]"),
      cardsAnual = document.querySelectorAll(
        ".cards[data-card='anual'] .item"
      ).length,
      cardsMensal = document.querySelectorAll(
        ".cards[data-card='mensal'] .item"
      ).length,
      url = document.location.href;

    if (verifyBtn[0].innerHTML.length && verifyBtn[1].innerHTML.length) {
      $abas.style.display = "flex";
    }

    $btns.forEach(($btn) => {
      $btn.addEventListener("click", (event) => {
        $btns.forEach(($btnClass) => $btnClass.classList.remove("active"));

        event.target.classList.add("active");

        $cards.forEach(($card) => {
          if (!$card.closest(".tns-outer")) {
            return;
          }

          $card.classList.remove("show");
          $card.closest(".tns-outer").classList.remove("show");
        });

        let $cardContent = document.querySelector(
          `.cards[data-card="${$btn.getAttribute("data-ref")}"]`
        );

        if (window.innerWidth <= 760) {
          $cardContent.classList.add("show");
          $cardContent.closest(".tns-outer").classList.add("show");
        } else {
          $cards.forEach(($card) => {
            $card.classList.remove("show");
          });
          $cardContent.classList.add("show");
        }
      });
    });

    $btns[0].click();
    cardsAnual && !cardsMensal && $btns[1].click();
    // if (
    //   (url.search(/plano=65A/gi) > -1 || url.search(/plano=54A/gi) > -1) &&
    //   url.search(/movimento=parceiros/gi) === -1
    // )
    //   $btns[1].click();
  },
};
